import styled from 'styled-components';

import colors from '../../styles/colors';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 1.5rem 1rem;
`;

export const Header = styled.header`
	width: 100%;
	display: flex;
	align-items: center;

	margin-bottom: 1.5rem;

	.centered {
		display: flex;
		flex: 1;
		justify-content: center;
	}

	.flex-1 {
		flex: 1;

		.button-label {
			display: none;

			@media screen and (min-width: 768px) {
				display: block;
			}
		}
	}
`;

export const Picture = styled.picture`
	display: flex;
	height: 3.125rem;

	img {
		height: 100%;
	}
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	max-width: 55rem;
	background-color: white;
	border: 1px solid ${colors.neutralForm};
	border-radius: 0.375rem;
	padding: 2rem 1rem 1.5rem;

	.description {
		margin-top: 1rem;
	}

	@media screen and (min-width: 768px) {
		padding: 3.4375rem 1rem 1.5rem;
	}
`;

export const FormWrapper = styled.form`
	display: flex;
	flex-direction: column;
	width: 100%;
	max-width: 25.625rem;
	margin: 2rem auto 0;

	.avatar-element {
		align-self: center;
		margin: 1.5rem 0;
	}

	.form-group {
		display: flex;
		flex-direction: column;

		& > * + * {
			margin-top: 1.25rem;
		}
	}

	.school-group {
		display: flex;
		flex-direction: column;
		margin-top: 1.875rem;

		& > * + * {
			margin-top: 1rem;
		}
	}

	.submit-button {
		margin-top: 3.4375rem;
		align-self: center;
	}
`;

export const InformationCard = styled.div`
	display: flex;
	padding: 0.5rem 0.75rem;
	background-color: ${colors.neutralBackground};
	border: 1px solid ${colors.neutralForm};
	border-radius: 0.375rem;

	.icon-wrapper {
		display: flex;
		justify-content: center;
		width: 1.25rem;
		color: ${colors.brandPrimary};
	}

	.info-wrapper {
		margin-left: 0.75rem;
		color: #000000;

		.info-line {
			display: flex;
			margin-top: 0.5rem;
			color: ${colors.neutralButton};

			svg {
				width: 1rem;
				height: 1rem;
			}

			p {
				margin-left: 0.5rem;
			}
		}
	}
`;
